import React from 'react';
import SarasLogTrans from '../../../../../library/translation/SarasLogTrans';

const ProdPlanPopupAuditData = ({ audit }) => {
    if (!audit) {
        return null;
    }

    return (
        <div className='uiProdPlanPopupAuditRow uiDivider uiSpacer5'>
            <div className='uiProdPlanPopupAuditMeta'>
                <span className='uiProdPlanPopupAuditUser uiSpacerH5 uiBlue uiUnHighlight'>{audit.loggedBy || ''}</span>
                <span className='uiProdPlanPopupAuditTime uiSpacerH5 uiGrey uiUnHighlight'>{audit.logTime || ''}</span>
            </div>
            <div className='uiProdPlanPopupAuditMessage uiSpacerH5'>
                <SarasLogTrans value={audit.message || ''} transObject={audit.transObject || ''} />
            </div>
        </div>
    );
};

export default ProdPlanPopupAuditData;
